export enum SocialSpacesEndpoints {
    GetSocialSpaces = '/v1/social-spaces',
    GetFiltersTree = '/v1/social-spaces/filters-tree',
    GetMySocialSpaceBookings = '/v1/social-spaces/bookings',
    GetSocialSpace = '/v1/social-spaces/{id}',
    GetSocialSpaceSlots = 'v1/social-spaces/{id}/slots',
    PostSocialSpaceBooking = 'v1/social-spaces/booking',
    CancelSocialSpaceBooking = 'v1/social-spaces/booking/{id}/cancel',
}
